import { LOCAL_STORAGE_KEYS } from '../constants/storage';

const MANUAL_WHITELIST = [
  'redirectTo',
  'userSettings',
  'theme',
  'softwareiq-theme',
  'sessionToken',
  'recentSearches',
  'selectedCategory',
  'selectedfields',
  'compsheetFields',
  'tickerFavorites',
  'softwareiq:financials:recent-metrics',
  'softwareiq:financial-dashboard:show-valuation',
  LOCAL_STORAGE_KEYS.SOURCE_CHECK_DOCUMENT_APPEARANCE,
];

// Include Auth0 keys or prefixes
function isWhitelistedKey(key) {
  return (
    MANUAL_WHITELIST.includes(key) ||
    key.startsWith('@@auth0') ||         // Default Auth0 SPA SDK key
    key.startsWith('__@@auth0') ||       // Sometimes used in certain SDKs
    key.startsWith('auth0.') ||          // Just in case for legacy or custom setups
    key.startsWith('softwareiq:analytics:checkout:') ||
    key.includes('auth0')                // Catch-all for anything auth0-related
  );
}

export function cleanLocalStorageOlderThan(days = 1) {
  const now = Date.now();
  const maxAge = days * 24 * 60 * 60 * 1000;

  const keysToDelete = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (isWhitelistedKey(key)) continue;

    try {
      const item = JSON.parse(localStorage.getItem(key));

      if (item?.timestamp && now - item.timestamp > maxAge) {
        keysToDelete.push(key);
      } else if (!item?.timestamp) {
        keysToDelete.push(key);
      }
    } catch (e) {
      keysToDelete.push(key); // If it's malformed or not JSON
    }
  }

  keysToDelete.forEach(key => localStorage.removeItem(key));
}
